import { Card, Tag, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

interface StubPageProps {
  titleKey: string;
  titleNs?: string;
  sprint: 1 | 2 | 3;
  description?: string;
  descriptionKey?: string;
}

/**
 * Placeholder screen for routes that have not yet been built out.
 * Stamps each stub with its owning sprint, so the handoff to design-system
 * and sprint-planner is unambiguous.
 */
export default function StubPage({
  titleKey,
  titleNs,
  sprint,
  description,
  descriptionKey,
}: StubPageProps) {
  const { t } = useTranslation(titleNs ? [titleNs, 'common'] : ['common']);
  const title = titleNs ? t(`${titleNs}:${titleKey}`) : t(titleKey);
  const desc =
    descriptionKey && titleNs
      ? t(`${titleNs}:${descriptionKey}`)
      : description ?? '';

  const sprintColor = sprint === 1 ? 'blue' : sprint === 2 ? 'purple' : 'magenta';

  return (
    <Card>
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Space>
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          <Tag color={sprintColor}>{t('common:status.comingInSprint', { n: sprint })}</Tag>
        </Space>
        {desc && <Paragraph type="secondary">{desc}</Paragraph>}
        <Paragraph type="secondary">
          This screen is a placeholder. The shell, i18n/RTL, role switcher, and mock data layer are
          functional. Detailed UI for this module lands in Sprint {sprint}.
        </Paragraph>
      </Space>
    </Card>
  );
}
